const DEFAULT_ASSET_BASE = 'https://osirus.ai'

const stripTrailingSlash = (s: string) => s.replace(/\/$/, '')

/**
 * Resolve asset base in a browser-safe way (no process.env).
 *
 * Priority:
 * 1) window.__OSIRUS_ASSET_BASE (optional runtime override)
 * 2) <script data-osirus-asset-base="..."> (optional)
 * 3) DEFAULT_ASSET_BASE
 */
function resolveAssetBase(): string {
  if (typeof window !== 'undefined') {
    const w = window as any

    if (typeof w.__OSIRUS_ASSET_BASE === 'string' && w.__OSIRUS_ASSET_BASE.trim()) {
      return stripTrailingSlash(w.__OSIRUS_ASSET_BASE.trim())
    }

    const script = document.querySelector('script[data-osirus-asset-base]') as
      | HTMLScriptElement
      | null

    const attr = script?.getAttribute('data-osirus-asset-base')
    if (attr && attr.trim()) return stripTrailingSlash(attr.trim())
  }

  return stripTrailingSlash(DEFAULT_ASSET_BASE)
}

const ASSET_BASE = resolveAssetBase()

const img = (path: string) => `${ASSET_BASE}${path}`

export const Images = {
  // bots
  bot: img('/images/logo/Osirus-Logo-Icon.svg'),

  // users
  personDark: img('/images/defaults/Login-Person-Icon-dark.svg'),
  personLight: img('/images/defaults/Login-Person-Icon.svg'),

  // logos
  logoIcon: img('/images/logo/Osirus-Logo-Icon.svg'),
  logoFull: img('/images/logo/Osirus-Logo-Horizontal.svg'),
} as const
